export default {
  title: '会員ランク特典',
  addLevel: '会員ランクを追加',
  levelName: 'ランク名',
  levelNamePlaceholder: 'ランク名を入力してください',
  addI18n: '多言語を追加',
  addTitle: '新規会員ランク追加',
  editTitle: '会員ランクを編集',
  deleteConfirm: '削除後は元に戻せません。削除してもよろしいですか？',
  columns: {
    level: 'ランク',
    name: 'ランク名',
    growth: '必要成長値',
    memberCount: '会員数',
    sort: '並び替え',
    status: 'ステータス',
    benefitCount: '会員数',
  },
  form: {
    baseInfo: '基本情報',
    levelName: '会員ランク名',
    levelNamePlaceholder: 'ランク名を入力してください',
    levelNameRequired: 'ランク名を入力してください',
    namePlaceholder: 'ランク名を入力してください',
    growthValue: '会員成長値',
    growthValuePlaceholder: '成長値を入力してください',
    growthValueRequired: '成長値を入力してください',
    birthdayGift: '誕生日ギフト',
    birthdayGiftDesc: 'ユーザーの誕生日に、システムが自動的にポイント奖励を送信します',
    sendPoints: 'ポイントを送る',
    pointsPlaceholder: '入力してください',
    pointsUnit: 'ポイント',
    birthdayPointsRequired: 'ポイント数を入力してください',
    discountPrivilege: '割引特典',
    discountPrivilegeDesc: 'ポイントでギフトを交換する際に割引が適用されます',
    pointsExchangeGift: 'ポイントでギフトを交換',
    discountPlaceholder: '入力してください',
    discountUnit: '割',
    discountRequired: '割引値を入力してください',
  },
  i18nEditTitle: '多言語編集',
  i18nModal: {
    title: '多言語（ランク名）',
    nameSuffix: 'ランク名',
  },
};
